export default [
  {
    reducerKey: 'marketplace-tools/list',
    sagaKey: 'marketplaceToolsSaga',
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-marketplace-tools" */ 'modules/MarketplaceTools/ToolsList/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-marketplace-tools" */ 'modules/MarketplaceTools/ToolsList/store/saga'
      ),
  },
  {
    reducerKey: 'marketplace-tools/details',
    sagaKey: 'marketplaceToolDetailsSaga',
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-marketplace-tools" */ 'modules/MarketplaceTools/ToolDetails/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-marketplace-tools" */ 'modules/MarketplaceTools/ToolDetails/store/saga'
      ),
  },
  {
    reducerKey: 'marketplace-tools/subscriptions',
    sagaKey: 'marketplaceToolsSubscriptionsSaga',
    routeKeys: ['marketplace-tools/subscriptions', 'marketplace-tools/subscribe'],
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-marketplace-tools" */ 'modules/MarketplaceTools/Subscriptions/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-marketplace-tools" */ 'modules/MarketplaceTools/Subscriptions/store/saga'
      ),
  },
  {
    reducerKey: 'marketplace-tools/payment',
    sagaKey: 'marketplaceToolsPaymentSaga',
    routeKeys: ['marketplace-tools/payment'],
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-marketplace-tools" */ 'modules/MarketplaceTools/Payment/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-marketplace-tools" */ 'modules/MarketplaceTools/Payment/store/saga'
      ),
  },
  {
    reducerKey: 'countries',
    sagaKey: 'countriesSaga',
    routeKeys: ['marketplace-tools/subscribe'],
    importReducer: () =>
      import(/* webpackChunkName: "domain-marketplace-tools" */ 'modules/Countries/store/reducer'),
    importSaga: () =>
      import(/* webpackChunkName: "domain-marketplace-tools" */ 'modules/Countries/store/saga'),
  },
]
